import { CardContent, CardMedia, Grid, Typography } from '@mui/material';
import moment from 'moment';
import 'moment/locale/pt-br';
import React, { useState } from 'react';
import { Button, Modal } from '../../../components';
import {
  useDispatch,
  useSelector,
  historySlice
} from '../../../stores';
import { handleMoney } from '../../../utils';
import { TicketSendEmailModal } from './TicketSendEmailModal';
import { StyledButtonsWrapper, StyledModalWrapper } from '../styles';
import 'react-credit-cards/es/styles-compiled.css';

export const TicketDetaisModal: React.FC = () => {
  const dispatch = useDispatch();

  const {
    ticketDetails,
    ticketDetailsIsOpen,
    ticketDetailsIsLoading,
    sendTicketByEmailLoading,
  } = useSelector((state) => state.historyReducer);

  const [isTicketSendModalOpen, setIsTicketSendModalOpen] = useState(false);

  const handleClose = () => {
    dispatch(historySlice.actions.toggleTicketDetailsIsOpen());
  };

  return (
    <Modal
      open={ticketDetailsIsOpen}
      onClose={handleClose}
      title='Detalhes de ticket'
      isLoading={ticketDetailsIsLoading}
    >
      <StyledModalWrapper>
        <Grid
          item
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'stretch',
          }}
        >
          <Grid spacing={1}>
            <CardMedia
              component='img'
              height='220'
              image={`data:image/png;base64,${ticketDetails?.routeImg}`}
            />
          </Grid>
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  gutterBottom
                  color='primary'
                  component='div'
                  sx={{
                    fontSize: '1.2em',
                  }}
                >
                  {ticketDetails?.routeName}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Horário do registro:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {moment(ticketDetails?.registrationDateTime).format(
                    'DD/MM/yyyy HH:mm:ss',
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Horário inicial:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {moment(ticketDetails?.entryDateTime).format(
                    'DD/MM/yyyy HH:mm:ss',
                  )}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Horário final:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {moment(ticketDetails?.exitDateTime).format(
                    'DD/MM/yyyy HH:mm:ss',
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid container sx={{ marginTop: 2 }}>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Placa:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {ticketDetails?.licensePlate}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Período:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {
                    (ticketDetails?.exitDateTime == ticketDetails?.entryDateTime)
                      ? '0seg'
                      : moment.duration(moment(ticketDetails?.exitDateTime, 'YYYY-MM-DD HH:mm:ss').diff(moment(ticketDetails?.entryDateTime, 'YYYY-MM-DD HH:mm:ss'))).humanize()
                  }
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                  }}
                  noWrap
                >
                  Valor:&nbsp;
                </Typography>
                <Typography
                  color='primary'
                  sx={{
                    fontSize: '0.75em',
                  }}
                  noWrap
                >
                  {handleMoney(ticketDetails?.price)} (
                  <Typography
                    color='primary'
                    sx={{
                      fontSize: '0.75em',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                    }}
                    noWrap
                  >
                    {ticketDetails?.paymentMethod}
                  </Typography>
                  )
                </Typography>
              </Grid>
            </Grid>
            {ticketDetails?.paymentMethod !== 'PIX' && (
              <Grid container sx={{ marginTop: 2 }}>
                <Grid item xs={12}>
                  <Typography
                    color='primary'
                    sx={{
                      fontSize: '0.75em',
                      fontWeight: 'bold',
                    }}
                    noWrap
                  >
                    Pago pelo aplicativo:
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    color='primary'
                    sx={{
                      fontSize: '0.75em',
                      fontWeight: 'bold',
                    }}
                    noWrap
                  >
                    Cartão:&nbsp;
                  </Typography>
                  <Typography
                    color='primary'
                    sx={{
                      fontSize: '0.75em',
                    }}
                    noWrap
                  >
                    **** {ticketDetails?.cardNumber} (
                    <Typography
                      color='primary'
                      sx={{
                        fontSize: '0.75em',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                      }}
                      noWrap
                    >
                      {ticketDetails?.cardBrand}
                    </Typography>
                    )
                  </Typography>
                </Grid>
              </Grid>
            )}
            {ticketDetails?.irregularities && ticketDetails?.irregularities && (
              <Grid container sx={{ marginTop: 2 }}>
                {ticketDetails?.irregularities && (
                  <Grid item xs={12}>
                    <Typography
                      color='primary'
                      sx={{
                        fontSize: '0.75em',
                        fontWeight: 'bold',
                      }}
                      noWrap
                    >
                      Irregularidades:&nbsp;
                    </Typography>
                    <Typography
                      color='primary'
                      sx={{
                        fontSize: '0.75em',
                      }}
                      noWrap
                    >
                      {Array.isArray(ticketDetails?.irregularities) ? ticketDetails?.irregularities?.join(', ') : JSON.parse(ticketDetails?.irregularities)?.join(',')}
                    </Typography>
                  </Grid>
                )}
                {ticketDetails?.observation && (
                  <Grid item xs={12}>
                    <Typography
                      color='primary'
                      sx={{
                        fontSize: '0.75em',
                        fontWeight: 'bold',
                      }}
                      noWrap
                    >
                      Observação:&nbsp;
                    </Typography>
                    <Typography
                      color='primary'
                      sx={{
                        fontSize: '0.75em',
                      }}
                      noWrap
                    >
                      {ticketDetails?.observation}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            )}
          </CardContent>
        </Grid>
        <StyledButtonsWrapper>
          <Button
            variant='contained'
            label='Enviar por email'
            type='submit'
            onClick={() => setIsTicketSendModalOpen(true)}
            color='secondary'
            loading={sendTicketByEmailLoading}
            style={{ width: '100%' }}
          />
        </StyledButtonsWrapper>
        <TicketSendEmailModal
          isOpen={isTicketSendModalOpen}
          handleClose={() => setIsTicketSendModalOpen(false)}
          isLoading={sendTicketByEmailLoading}
        />
      </StyledModalWrapper>
    </Modal>
  );
};